import React from 'react'
import {
    Button, Container,
    Row, Col, Label, Input,
    Table,
} from 'reactstrap'
import {
    MACHINE_NAMES,
    IMPERFECTIONS,
    getPlatesFromTime,
} from '../model/request/machine'
import dateFormat from 'dateformat'
import DateTextField from '../view/DateTextField'
import { JustDate } from '../model/JustDate'

function expected_end_time(machine) {
  if (machine.end_time) {
    return machine.end_time;
  } else {
    return machine.start_time + machine.expected_time;
  }
}

function findToolInMachine(machine, toolNumber) {
    return machine.tool_info.find((tool) => tool.tool_number == toolNumber)
}

function dateToSeconds(date) {
    return date.toDateTime().getTime() / 1000
}

function getToolInfo(toolInfos, toolNumber) {
    for (let i = 0; i < toolInfos.length; i++) {
        if (toolInfos[i].tool_number === toolNumber) {
            return toolInfos[i]
        }
    }
    return null
}

function isTwoPlatesLevel(plate1, plate2) {
    if (!plate1 || !plate2) {
        return true;
    }

    let plate1ToolInfo3 = getToolInfo(plate1.tool_info, 3)
    let plate1ToolInfo5 = getToolInfo(plate1.tool_info, 5)

    let plate2ToolInfo3 = getToolInfo(plate2.tool_info, 3)
    let plate2ToolInfo5 = getToolInfo(plate2.tool_info, 5)

    if (
        !plate1ToolInfo3 || !plate1ToolInfo5 ||
        !plate2ToolInfo3 || !plate2ToolInfo5
    ) {
        return true
    }

    if (
        plate1ToolInfo3.feed_rate < plate2ToolInfo3.feed_rate ||
        plate1ToolInfo5.feed_rate < plate2ToolInfo5.feed_rate
    ) {
        return true;
    }

    let tool3Growth = plate1ToolInfo3.length - plate2ToolInfo3.length
    let tool5Growth = plate1ToolInfo5.length - plate2ToolInfo5.length


    if (abs(tool3Growth - tool5Growth) >= 0.0005) {
        return false
    }
    return true
}

function platesWithDifferent(plates) {
    let badPlates = []

    for (let i = 0; i < MACHINE_NAMES.length; i++) {
        let prevPrevPlate = null;
        let prevPlate = null;
        for (let j = 0; j < plates.length; j++) {
            if (plates[j].machine !== MACHINE_NAMES[i]) {
                continue;
            }

            let currentToolInfo3 = getToolInfo(plates[j].tool_info, 3)
            let currentToolInfo5 = getToolInfo(plates[j].tool_info, 5)

            if (!currentToolInfo3 || !currentToolInfo5) {
                continue;
            }

            if (!prevPlate) {
                prevPlate = plates[j]
                continue;
            }

            if (!prevPlate) {
                prevPrevPlate = prevPlate
                prevPlate = plates[j]
                continue;
            }

            if (plates[j].imperfections.length === 0) {
                prevPrevPlate = prevPlate
                prevPlate = plates[j]
                continue;
            }

            if (
                !isTwoPlatesLevel(prevPrevPlate, prevPlate) ||
                !isTwoPlatesLevel(prevPlate, plates[j])
            ) {
                badPlates.push(prevPlate)
            }

            prevPrevPlate = prevPlate
            prevPlate = plates[j]
        }
    }

    return badPlates
}

function newTool(plates, toolNumber) {
    let badPlates = []

    for (let i = 0; i < MACHINE_NAMES.length; i++) {
        let prevPlate = null
        for (let j = 0; j < plates.length; j++) {
            if (plates[j].machine !== MACHINE_NAMES[i]) {
                continue
            }

            if (!prevPlate) {
                prevPlate = plates[j]
                continue
            }

            let toolCurrent = getToolInfo(plates[j].tool_info, toolNumber)
            let toolPrev = getToolInfo(prevPlate.tool_info, toolNumber)

            // Was not in use
            if (!toolCurrent || !toolPrev || toolCurrent.feed_rate === 0) {
                prevPlate = plates[j]
                continue
            }

            if (toolCurrent.feed_rate > toolPrev.feed_rate) {
                badPlates.push(prevPlate)
            }

            prevPlate = plates[j]
        }
    }

    return badPlates
}

function abs(x) {
    if (x < 0) {
        return -x
    }
    return x
}

function timeFrame(plates) {
    if (plates.length <= 2) {
        return null
    }

    let machineTimes = []
    let totalDownTimes = []
    let majorDownStartTimes = []

    let platesCount = 0

    let prices = []
    let pricesMachineTime = 0.0

    let lastEndTime = plates[0].start_time

    for (let i = 0; i < plates.length; i++) {
        if (i + 1 < plates.length && plates[i].start_time < plates[i+1].end_time && plates[i].machine === plates[i+1].machine) {
            continue
        }
        platesCount += 1
        let plateTime = plates[i].end_time - plates[i].start_time
        machineTimes.push(plateTime)
        if (plates[i].height * plates[i].width > 3.0) {
            prices.push(plates[i].height * plates[i].width * 0.3)
            pricesMachineTime += plateTime
        }
        if (i + 1 < plates.length) {
            const downTime = plates[i].start_time - plates[i+1].end_time
            totalDownTimes.push(downTime)
            if (downTime > 10 * 60) {
                majorDownStartTimes.push({'start_time': plates[i+1].end_time, 'duration': downTime, 'end_time': plates[i].start_time})
            }
        }
    }

    let totalWeightedMachineTime = 0.0
    for (let i = 0; i < machineTimes.length; i++) {
        totalWeightedMachineTime += machineTimes[i] * machineTimes[i]
    }

    totalDownTimes.sort((l, r) => l-r)
    machineTimes.sort((l, r) => l-r)
    prices.sort((l, r) => l-r)

    const medianDownTime = totalDownTimes[Math.floor(totalDownTimes.length/2)]
    const medianMachineTime = machineTimes[Math.floor(machineTimes.length/2)]
    const medianPrice = prices[Math.floor(prices.length/2)]

    // Finding the optimal total downtime
    let totalOptimalDowntime = 0.0
    for (let i = 0; i < plates.length; i++) {
        if (i + 1 < plates.length && plates[i].start_time < plates[i+1].end_time) {
            continue
        }
        if (i + 1 < plates.length) {
            const downTime = plates[i].start_time - plates[i+1].end_time
            if (downTime > medianDownTime) {
                totalOptimalDowntime += medianDownTime
            } else {
                totalOptimalDowntime += downTime
            }
        }
    }

    return {
        'totalMachineTime': machineTimes.sum(),
        'weightedMachineTime': totalWeightedMachineTime / machineTimes.sum(),
        'averagePrice': prices.sum() / (pricesMachineTime / (60.0 * 60.0)),
        'totalPrice': prices.sum(),
        medianMachineTime,
        majorDownStartTimes,
        medianDownTime,
        totalOptimalDowntime,
        platesCount,
        'totalDownTime': totalDownTimes.sum(),
    }
}

function operatorUtilization(jobs) {
    if (jobs.length === 0) {
        return 0.0
    }

    jobs = JSON.parse(JSON.stringify(jobs))
    jobs = jobs.sort((l, r) => {
        return l.start_time - r.start_time
    })

    let machinesTimes = []
    let indexes = []
    let plateCount = 0
    for (let i = 0; i < MACHINE_NAMES.length; i++) {
        let times = []
        for (let j = 0; j < jobs.length; j++) {
            if (jobs[j].machine !== MACHINE_NAMES[i]) {
                continue;
            }

            if (times.length === 0 || times[times.length-1] < jobs[j].start_time) {
                times.push(jobs[j].start_time);
                times.push(jobs[j].end_time);
                plateCount += 1
            }
        }

        indexes.push(0)
        machinesTimes.push(times)
    }

    let machinesRunnings = 0
    let startTime = 0;
    let timeAllMachinesInUse = 0.0
    let lastTime = 0;

    while (true) {
        let next = [startTime, 0, false]
        for (let i = 0; i < machinesTimes.length; i++) {
            if (indexes[i] >= machinesTimes[i].length) {
                continue;
            }
            if (!next[2] || next[0] > machinesTimes[i][indexes[i]]) {
                next = [machinesTimes[i][indexes[i]], i, true]
            }
        }

        if (!next[2]) {
            break;
        }

        if (startTime === 0) {
            lastTime = next[0]
            startTime = next[0]
        }

        if (machinesRunnings >= machinesTimes.length) {
            timeAllMachinesInUse += next[0] - lastTime
        }

        if (indexes[next[1]] % 2 === 0) {
            machinesRunnings += 1;
        } else {
            machinesRunnings -= 1;
        }

        lastTime = next[0]
        indexes[next[1]] += 1
    }
    
    let totalTime = lastTime - startTime
    return {
        'operator_utilization': (totalTime - timeAllMachinesInUse) / totalTime,
        'three_minute_utilization': (plateCount * 3.0 * 60) / totalTime
    }
}

class PlatesViewerViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)

        let startDate = new Date()
        startDate.setDate(startDate.getDate()-1)
        this.state = {
            'plates': [],
            'tool_numbers': [],
            'start_date': new JustDate(startDate),
            'end_date': new JustDate(new Date()),
            'table_row_hover': null,
        }
    }

    search() {
        this.props.turnOnLoader()
        getPlatesFromTime(
          dateToSeconds(this.state.start_date),
          dateToSeconds(this.state.end_date),
        ).then(
            (result) => {
                this.setState({
                    'plates': result.filter((plate) => plate.end_time),
                    'tool_numbers': [...new Set(
                        result.map((item) => item.tool_info.map(
                            (item) => item.tool_number
                        )).flat())
                    ].sort((a, b) => {
                        return Number.parseInt(a) - Number.parseInt(b);
                    }),
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    secondsToDate(seconds) {
      let d = new Date(0);
      d.setUTCSeconds(seconds);
      return d;
    }

    formatSeconds(seconds) {
      if (!seconds) {
        return ""
      }
      return dateFormat(this.secondsToDate(seconds), 'mmmm d, yyyy hh::MM tt')
    }

    hasMachines() {
      return this.state.latest_index < this.state.machines.length
    }

    latestMachine() {
      return this.state.machines[this.state.latest_index]
    }

    labelAndValue(label, value) {
      return <Col><Container>
        <Row><Col><Label>{label}</Label></Col></Row>
        <Row><Col><Label>{value}</Label></Col></Row>
      </Container></Col>
    }

    checkBox(plate, imperfection) {
        return <Input
            type="checkbox"
            checked={plate.imperfections.indexOf(imperfection) !== -1}
        />
    }

    makeRows(plates) {
      return plates.map((machine) => {
        return <tr>
          <td style={{'minWidth': '130px'}}>{machine.file_name}</td>
          {
            IMPERFECTIONS.map((imp) => <td style={{'minWidth': '130px'}}>{this.checkBox(machine, imp.var_name)}</td>)
          }
          <td style={{'minWidth': '150px'}}>{this.formatSeconds(machine.start_time)}</td>
          <td style={{'minWidth': '150px'}}>{this.formatSeconds(machine.end_time)}</td>
          <td style={{'minWidth': '130px'}}>{machine.machine}</td>
          <td style={{'minWidth': '130px'}}>{machine.operator}</td>
          <td style={{'minWidth': '130px'}}>{Math.ceil((expected_end_time(machine) - machine.start_time) / 60)}</td>
          <td style={{'minWidth': '130px'}}>{machine.humidity}</td>
          <td style={{'minWidth': '130px'}}>{machine.air_quality}</td>
          <td style={{'minWidth': '130px'}}>{machine.pressure}</td>
          <td style={{'minWidth': '130px'}}>{machine.temperature}</td>
          <td style={{'minWidth': '130px'}}>{machine.height}</td>
          <td style={{'minWidth': '130px'}}>{machine.width}</td>
          <td style={{'minWidth': '600px'}}>{machine.version}</td>
          {
              this.state.tool_numbers.map(
                  (toolNumber) => {
                      const tool = findToolInMachine(machine, toolNumber);
                      if (!tool) {
                          return <><td
                            style={{'minWidth': '150px'}}
                          ></td><td
                            style={{'minWidth': '150px'}}
                          ></td></>
                      }

                      return <>
                        <td style={{'minWidth': '150px'}}>
                            {tool.feed_rate}
                        </td>
                        <td style={{'minWidth': '150px'}}>
                            {tool.length}
                        </td>
                      </>
                  }
              )
          }
        </tr>
      })
    }

    buildSmallRow(plates) {
        if (this.state.table_row_hover === 'file_name') {
            return <Table
                style={{
                    'position': 'absolute',
                    'width': '100px',
                    'background': '#3c3c3c',
                }} >
                <thead
                    style={{
                        'display': 'block'
                    }}
                >
                    <tr
                        style={{
                            'height': '65px',
                        }}
                    >
                        <th className="text-center label-weight"
                            style={{'minWidth': '130px'}} onClick={() => { this.setState({
                                'table_row_hover': 'file_name',
                            })}}>File Name</th>
                    </tr>
                </thead>
                <tbody>
                    {plates.map((plate) => {
                        return <tr>
                            <td style={{'minWidth': '130px'}}>{plate.file_name}</td>
                        </tr>
                    })}
                </tbody>
            </Table>
        }
        return <></>
    }

    buildTable(machine, isToolPathVersion=false) {

      const plates = this.state.plates.filter((plate) => (!isToolPathVersion && plate.machine === machine) || (isToolPathVersion && plate.version === machine))
      const tf = timeFrame(plates)

      return <>
        <Row><Col><Label
          style={{
            'fontSize': '20px',
            'fontWeight': '400',
          }}
          >{machine}</Label></Col></Row>
        <Row><Col>
            <div>
                {this.buildSmallRow(
                  this.state.plates.filter((plate) => plate.machine === machine)
                  )}
            <Container style={{'overflowX': 'auto'}}><Table>
            <thead
                style={{
                    'display': 'block'
                }}
            >
                <tr>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}} onClick={() => { this.setState({
                            'table_row_hover': 'file_name',
                        })}}>File Name</th>
                    {
                        IMPERFECTIONS.map((imp) => 
                            <th className="text-center label-weight"
                                style={{'minWidth': '130px'}}>{imp.display_name}</th>
                        )
                    }
                    <th className="text-center label-weight"
                        style={{'minWidth': '150px'}}>Start Time</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '150px'}}>End Time</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Machine</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Operator</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Machine Time</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Humidity</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Air Quality</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Pressure</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Temperature</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Height</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '130px'}}>Width</th>
                    <th className="text-center label-weight"
                        style={{'minWidth': '600px'}}>Version</th>
                    {
                        this.state.tool_numbers.map(
                            (toolNumber) => <>
                                <th className="text-center label-weight"
                                    style={{'minWidth': '150px'}}>Tool {toolNumber} Feed Rate Hours</th>
                                <th className="text-center label-weight"
                                    style={{'minWidth': '150px'}}>Tool {toolNumber} Length</th>
                            </>
                        )
                    }
                </tr>
            </thead>
            <tbody
                style={{
                    'display': 'block',
                    'maxHeight': '500px',
                    'overflowY': 'auto',
                    'overflowX': 'hidden',
                }}
            >
                {this.makeRows(
                    plates
                )}
            </tbody>
      </Table></Container>
            { tf === null ? <></> : 
                <>
                    <Label style={{'fontWeight': '400'}}>Plate Count</Label> <Label>{tf.platesCount} Plates</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Total Value</Label> <Label>{'$' + tf.totalPrice.toFixed(2)}</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Value</Label> <Label>{'$' + tf.averagePrice.toFixed(2)} per hour</Label>
                    <br/>
                    {isToolPathVersion ? <>
                        <Label style={{'fontWeight': '400'}}>Optimal Value in a 5 day week 90% success rate 6 HAAS machines 95% Utilization </Label> <Label>{'$' + (tf.averagePrice * 5.0 * 0.9 * 0.95 * 24.0 * 6.0).toFixed(2)} per week </Label>
                        <br/>
                    </>
                    :<>
                    <Label style={{'fontWeight': '400'}}>Optimal Value in a 5 day week 90% success rate and MAZAKS are 20% slower </Label> <Label>{'$' + (tf.averagePrice * 5.0 * 0.9 * 0.93 * 24.0 * 10.0 * (tf.totalMachineTime / (tf.totalMachineTime + tf.totalOptimalDowntime))).toFixed(2)} per week </Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Optimal Value in a 7 day week </Label> <Label>{'$' + (tf.averagePrice * 7.0 * 24.0 * 10.0 * (tf.totalMachineTime / (tf.totalMachineTime + tf.totalOptimalDowntime))).toFixed(2)} per week </Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Machine Time</Label> <Label>{(tf.totalMachineTime / (60 * 60)).toFixed(2)} hours</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Machine Time Average</Label> <Label>{((tf.totalMachineTime/tf.platesCount) / (60)).toFixed(2)} minutes</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Machine Time Median</Label> <Label>{(tf.medianMachineTime / 60).toFixed(2)} minutes</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Machine Time Weighted</Label> <Label>{(tf.weightedMachineTime / (60)).toFixed(2)} minutes</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Total Down Time</Label> <Label>{(tf.totalDownTime / (60 * 60)).toFixed(2)} hours</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Median Down Time</Label> <Label>{(tf.medianDownTime / 60).toFixed(2)} minutes</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Average Down Time</Label> <Label>{((tf.totalDownTime/60) / (tf.platesCount-1)).toFixed(2)} minutes</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Utilization</Label> <Label>{(100 * tf.totalMachineTime / (tf.totalMachineTime + tf.totalDownTime)).toFixed(2)}%</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Optimal Utilization</Label> <Label>{(100 * tf.totalMachineTime / (tf.totalMachineTime + tf.totalOptimalDowntime)).toFixed(2)}%</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Utilization No Big Breaks</Label> <Label>{(100 * tf.totalMachineTime / (tf.totalMachineTime + tf.totalDownTime - tf.majorDownStartTimes.sum((x) => x.duration))).toFixed(2)}%</Label>
                    <br/>
                    <Label style={{'fontWeight': '400'}}>Big Breaks</Label><br/>
                    {tf.majorDownStartTimes.map((time) => <>
                        <Label style={{'fontWeight': '400', 'marginLeft': '20px'}}>Start Time</Label> <Label>{this.formatSeconds(time.start_time)}</Label>
                        <Label style={{'fontWeight': '400', 'marginLeft': '20px'}}>Duration</Label> <Label>{(time.duration / 60).toFixed(2)} minutes</Label>
                        <br/>
                    </>)
                    }
                    </>
                    }
                </>
            }
        </div></Col></Row>
      </>
    }

    render() {
        const opUtil = operatorUtilization(this.state.plates)
        return (
            <Container>
              <Row>
                <Col><Label
                  style={{
                    'fontSize': '20pt',
                    'fontWeight': '400',
                  }}
                >Start Date</Label>
                </Col>
                <Col><Label
                  style={{
                    'fontSize': '20pt',
                    'fontWeight': '400',
                  }}
                >End Date</Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <DateTextField
                      value={this.state.start_date}
                      showModal={this.props.showModal}
                      closeModal={this.props.closeModal}
                      onChange={(newDate) => {
                          this.setState({
                            'start_date': newDate,
                          })
                      }}
                  />
                </Col>
                <Col>
                  <DateTextField
                      value={this.state.end_date}
                      showModal={this.props.showModal}
                      closeModal={this.props.closeModal}
                      onChange={(newDate) => {
                          this.setState({
                            'end_date': newDate,
                          })
                      }}
                  />
                </Col>
              </Row>
              <Button
                color='primary'
                onClick={() => {
                    this.search()
                }}
              >Search</Button>
              {MACHINE_NAMES.map((name) => this.buildTable(name, false))}
              {[...new Set(this.state.plates.map((plate) => plate.version))].map((version) => this.buildTable(version, true))}
              <Row>
                <Col>
                    <Label>Tool Differences</Label>
                </Col>
                <Col>
                    <Label>{platesWithDifferent(this.state.plates).map((plate) => plate.file_name)}</Label>
                </Col>
                <Col>
                    <Label>New Eighth Inch Tool</Label>
                </Col>
                <Col>
                    <Label>{
                        newTool(this.state.plates, 3)
                            .filter((plate) => plate.imperfections.length !== 0)
                            .map((plate) => plate.file_name)
                    }</Label>
                    /
                    <Label>{newTool(this.state.plates, 3).length}</Label>
                </Col>
              </Row>
              <Row><Col>
                <Label style={{'bold': '500'}}>Operator Utilization</Label>
                <Label style={{'bold': '500', 'margin': '10px'}}>{(100 * opUtil.operator_utilization).toFixed(2)}%</Label>
                <br />
                <Label style={{'bold': '500'}}>3 Minute Change Over Operator Utilization</Label>
                <Label style={{'bold': '500', 'margin': '10px'}}>{(100 * opUtil.three_minute_utilization).toFixed(2)}%</Label>
              </Col></Row>

            <Row>
                <Col><Label
                    style={{
                        'fontWeight': '600',
                    }}
                    >Tool Numbers</Label>

                </Col>
            </Row>
            {this.state.tool_numbers.map((tool_number) => {
                  return <>
                    <Row>
                      <Col>
                        Tool {tool_number}
                      </Col>
                      <Col>
                        Usage {newTool(this.state.plates, tool_number).length}
                      </Col>
                    </Row>
                  </>
              })}
            </Container>
        )
    }
}

export default PlatesViewerViewController

